import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import ProgressLoader from 'Components/Widgets/ProgressLoader';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import MatButton from '@mui/material/Button';
// app config
import AppConfig from 'Constants/AppConfig';
import { 
    studentDetailsIDCard,
    studentsTravelForm,
    fetchTravelForm,
    parentViewAgreement,
    fetchStudentAgreement
 } from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import ViewIDCard from '../../../contract/studentid/component/studentidcard';
import AddItem from '../../../travelr/travelform/component/addform';
import UpdateItems from '../../../travelr/travelform/component/viewform';
import ViewElement from '../../../contract/students/component/agreement/viewagreement';
class GolfItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    
    constructor(props) {
      
        super(props);
        this.state = {  
            student:this.props.data.student, 
            loader:false,
            vid:false,
            vewcard:false,
            errdiv:false,
            editdiv:false,
            frm:2,
            edcheckoutdate:'',
            edcheckouttime:'',
            edcheckindate:'',
            edcheckintime:'',
            edleavecnt:'',
            edsepmore:0,
            edformvalue:[],   
            edacptcnt:0,
            viewdiv:true,
            vfm:2,
        };

        this.onBackSection = this.onBackSection.bind(this);
        this.onAddSession1 = this.onAddSession1.bind(this);
    }
    
    UNSAFE_componentWillMount() {
        // var stdid=localStorage.getItem('user_id');
        // this.setState({ 
        //     student:stdid
        // });
        var stdid=this.state.student;
        this.StudentsFullDetails(stdid);
        this.props.studentsTravelForm(stdid);
        this.props.parentViewAgreement();
	}

    StudentsFullDetails(stdid){

        this.props.studentDetailsIDCard(stdid)
         .then((data) => {
            if (data.status === 2) {               
               this.setState({
                    vewcard: false,
                    errdiv: true,
               });
            } else {
               this.setState({
                    vewcard: true,
                    errdiv: false,
               });
            }
        })
    }

    onAddSession1(cttfID){
            
        this.props.fetchTravelForm(cttfID)
        .then((data) => {
            if (data && data.data) {
                var resdata = data.data;
                var troption = resdata.troptions;
                var upttroption = resdata.updatetropt;
                var troptobj = []; 
                var leavcnt = '';
                var troptcnt = 0;
                
                if (upttroption.length === 0) {
                    troption.forEach((teamval) => {   
                        troptobj.push({
                            reasonfortravel: teamval.ctdy_options,
                            numberofdays: teamval.ctdy_days,
                            placetravellingto: teamval.ctdy_travel
                        });
                    });
        
                    leavcnt = resdata.travel[0].cttf_totaldays;
                    troptcnt = troption.length;
                } else {
                    upttroption.forEach((teamval) => {   
                        troptobj.push({
                            reasonfortravel: teamval.ctdy_options,
                            numberofdays: teamval.ctdy_days,
                            placetravellingto: teamval.ctdy_travel
                        });
                    });
                      
                    leavcnt = resdata.travel[0].cttf_acdyuptdays;
                    troptcnt = upttroption.length;
                } 
        
                var checkindate, checkintime;
        
                if (resdata.travel[0].cttf_acdyenterby !== "") {
                    checkindate = resdata.travel[0].cttf_acdycheckindate;
                    checkintime = resdata.travel[0].cttf_acdycheckintime;    
                } else {
                    checkindate = resdata.travel[0].cttf_checkindate;
                    checkintime = resdata.travel[0].cttf_checkindate; 
                }
        
                var acptcnt = resdata.travel[0].cttf_coachaccept + resdata.travel[0].cttf_sportsaccept + resdata.travel[0].cttf_academyaccept;
        
                this.setState({
                    edcheckoutdate: resdata.travel[0].cttf_checkoutdate,
                    edcheckouttime: resdata.travel[0].cttf_checkouttime,
                    edcheckindate: checkindate,
                    edcheckintime: checkintime,
                    edleavecnt: leavcnt,
                    edsepmore: troptcnt,
                    edformvalue: troptobj,
                    edacptcnt: acptcnt
                });
        
                this.setState({ 
                    viewdiv: false,
                    adddiv: false,
                    vdiv: true,
                });
            } else {
                console.error("Data format error:", data);
            }
        })
        .catch((error) => {
            console.error('Error fetching travel form:', error);
            // Handle the error here, such as displaying a message to the user or performing some fallback action
        });
    
    
     }

    onBackSection(){
        this.setState({ 
            adddiv:false,
            viewdiv:true,
            editdiv: false,
            vdiv:false,
            
        });

    }

    onAddSession() {
		this.setState({ 
         viewdiv:false,
         vdiv:false,
         adddiv:true,
      });
	}

    viewSession(id){
    
        this.props.fetchStudentAgreement(id).then((data) => {   
            this.setState({              
                viewdiv: false,                
                adddiv:false,
                vdiv:false,            
                editdiv: true,

            });
        });   
   }


render() {

    const { travelformlist, allparentagreement, loading} = this.props;
    const usrid=localStorage.getItem('user_id'); 
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        responsive:'standard',
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "chodate", label: "CHECK_OUT DATE" },
        { name: "chidate", label: "CHECK_IN DATE" },
        { name: "ttotaldays", label: "TOTAL DAYS" },
        { name: "action", label: "ACTION" },
      
    ];
    const tabledata=travelformlist.map((assmntval,idx) => {     

            const ebtn=<MatButton onClick={ ()=>this.onAddSession1(assmntval.cttfID)} className="btn-info mr-10 mb-10 text-white">View</MatButton>;                
                
            if(assmntval.cttf_acdyenterby==''){
               var totalday=assmntval.cttf_totaldays;
            }else{
              var totalday=assmntval.cttf_acdyuptdays;
            }

            return {
            no:idx+1,
            chodate: assmntval.choutdate,
            chidate: assmntval.chindate,
            ttotaldays: totalday,
            action: ebtn,
            
            }
    });

    const columns2 = [
        { name: "no", label: "NO" },
        { name: "type", label: "Agreement Type" },
        { name: "excdate", label: "Execution Date" },
        { name: "startdate", label: "Agreement Start Date" },
        { name: "enddate", label: "Agreement End Date" },
        { name: "action", label: "View" },
        { name: "action1", label: "Download" },
     ];

     const tabledata2 = allparentagreement.map((assmntval, idx) => {
        const ebtn = (<button class="mr-10 mb-10 btn btn-info btn-sm" onClick={() => this.viewSession(assmntval.ctsaID)}>View</button>);
        if(assmntval.ctsa_acceptedBy==0){
            var dbtn="";
        }else{
           var dbtn = (
               <a href={AppConfig.apiurl+'/ctagreementdownload?id='+assmntval.ctsaID+'&usrid='+usrid}><button class="mr-10 mb-10 btn btn-warning btn-sm">Download</button></a>
           );
        }

        return {
           no: idx + 1,
           type: assmntval.name,
           excdate: assmntval.exdate,
           startdate: assmntval.stdate,
           enddate: assmntval.eddate,
           action: ebtn,
           action1: dbtn,
        };
     });

      return(
        <div>       
                {this.state.viewdiv && 
                    <div className="row">
                       <div className="col-sm-12 col-lg-6">
                           {this.state.vewcard &&
                                <ViewIDCard onClick={this.onBackSection} data={this.state}/>
                           }
                           {this.state.errdiv &&
                                <div className="card">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col-6">
                                                <h3 className="mb-0">ID Card</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <h3 className="text-center" style={{color:"red",fontWeight:"bold"}}>Contract not available</h3>
                                    </div>    
                                </div>
                           }
                       </div>
                       <div className="col-sm-12 col-lg-6">
                            <div className="sss">
                                <RctCollapsibleCard heading="Travel List" fullBlock>
                                    <MUIDataTable
                                        title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add form</Button></div>}
                                        data={tabledata}
                                        columns={columns}
                                        options={options} 
                                    />   
                                </RctCollapsibleCard>
                            </div> 
                            <div className="ddd"> 
                                <RctCollapsibleCard heading="Contract List" fullBlock>
                                    <MUIDataTable
                                        data={tabledata2}
                                        columns={columns2}
                                        options={options}
                                    />
                                </RctCollapsibleCard>
                            </div>
                       </div>

                      

                    </div>
                }    

                {this.state.adddiv && 
                <AddItem onClick={this.onBackSection} />
                }

                {this.state.vdiv && 
                <UpdateItems onClick={this.onBackSection} data={this.state} />
                } 

                {this.state.editdiv &&
                    <ViewElement onClick={this.onBackSection} data={this.state} />
                }                   

                {this.state.loader &&
                <div className="col-lg-12">
                    <ProgressLoader />
                </div>
                }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ travelform, contractstudent}) => {
    const { travelformlist, loading } = travelform;
    const { allparentagreement } = contractstudent;
    return { travelformlist, allparentagreement, loading };
   
}


export default connect(mapStateToProps, {
    studentDetailsIDCard,
    studentsTravelForm,
    fetchTravelForm,
    parentViewAgreement,
    fetchStudentAgreement
})(GolfItems);
